/**
 * The homepage's drawn response curves — one generator, so the hero's seat
 * card and the journey's result card draw the same before and after.
 *
 * Illustrative, and said so where they are drawn: a sum of sines,
 * deterministic so the server and the client draw the same path. "Before" is
 * a room's peaks and nulls, "after" the same room evened out.
 */

type Ripple = readonly (readonly [amplitude: number, frequency: number, phase: number])[];

function curve(width: number, height: number, ripple: Ripple): string {
  const pts: string[] = [];
  for (let x = 0; x <= width; x += 4) {
    const y = height / 2 + ripple.reduce((s, [a, f, p]) => s + a * Math.sin(x * f + p), 0);
    pts.push(`${x === 0 ? 'M' : 'L'}${x} ${y.toFixed(1)}`);
  }
  return pts.join(' ');
}

/** Before and after at the seat, scaled to a plot of `height` (amplitudes
 *  were tuned on a 40-unit plot). */
export function seatCurves(width: number, height: number): { before: string; after: string } {
  const k = height / 40;
  return {
    before: curve(width, height, [[8.5 * k, 0.05, 0.4], [5.5 * k, 0.16, 1.1], [3.5 * k, 0.41, 2.3]]),
    after: curve(width, height, [[2 * k, 0.04, 0.8], [1.1 * k, 0.13, 1.7]]),
  };
}
